/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Hero_Image_AltInputs */

const en_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame corner with framed photos, plaques, and trophies`)
};

const es_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rincón del Salón de la Fama con fotos enmarcadas, placas y trofeos`)
};

const de_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecke der Ruhmeshalle mit gerahmten Fotos, Plaketten und Trophäen`)
};

const zh_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名人堂一角，陈列着装裱照片、纪念牌匾和奖杯`)
};

const ar_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ركن قاعة المشاهير بصور مؤطرة ولوحات تذكارية وكؤوس`)
};

const fr_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coin du Temple de la renommée avec photos encadrées, plaques et trophées`)
};

const vi_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Góc Đại sảnh Danh vọng với ảnh đóng khung, kỷ niệm chương và cúp`)
};

const sw_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kona ya Ukumbi wa Umaarufu yenye picha zilizowekwa kwenye fremu, mabamba ya heshima na vikombe`)
};

const th_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มุมหอเกียรติยศที่มีภาพถ่ายใส่กรอบ โล่ประกาศเกียรติคุณ และถ้วยรางวัล`)
};

const bs_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kutak Kuće slavnih s uramljenim fotografijama, plaketama i trofejima`)
};

const ja_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`額入りの写真、記念盾、トロフィーが並ぶホール・オブ・フェイムのコーナー`)
};

const ko_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`액자 사진, 기념패, 트로피가 놓인 명예의 전당 코너`)
};

const pt_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto do Hall da Fama com fotos emolduradas, placas e troféus`)
};

const it_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angolo della Hall of Fame con foto incorniciate, targhe e trofei`)
};

const sv_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame-hörna med inramade foton, plaketter och troféer`)
};

const nl_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoek van de Eregalerij met ingelijste foto's, plaquettes en trofeeën`)
};

const da_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame-hjørne med indrammede fotos, plaketter og trofæer`)
};

const nb_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame-hjørne med innrammede bilder, plaketter og trofeer`)
};

const fi_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunniagallerian nurkkaus, jossa on kehystettyjä valokuvia, laattoja ja pokaaleja`)
};

const pl_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kącik Galerii Sław z oprawionymi zdjęciami, tablicami pamiątkowymi i trofeami`)
};

const ru_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уголок Зала славы с фотографиями в рамках, памятными табличками и трофеями`)
};

const tr_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerçeveli fotoğraflar, plaketler ve kupalarla dolu Şöhretler Müzesi köşesi`)
};

const hi_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ फेम का कोना, जिसमें फ़्रेम की हुई तस्वीरें, पट्टिकाएँ और ट्रॉफ़ियाँ हैं`)
};

const id_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudut Balai Kehormatan dengan foto berbingkai, plakat, dan trofi`)
};

const ms_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudut Dewan Kemasyhuran dengan gambar berbingkai, plak dan trofi`)
};

const cs_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koutek Síně slávy se zarámovanými fotografiemi, plaketami a trofejemi`)
};

const el_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γωνιά του Πανθέου Διασήμων με κορνιζαρισμένες φωτογραφίες, πλακέτες και τρόπαια`)
};

const he_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פינת היכל התהילה עם תמונות ממוסגרות, לוחות הוקרה וגביעים`)
};

const af_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoek van die Eregalery met geraamde foto's, gedenkplate en trofeë`)
};

const hu_hof_hero_image_alt = /** @type {(inputs: Hof_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Hírességek csarnokának sarka bekeretezett fotókkal, emléktáblákkal és trófeákkal`)
};

/**
* | output |
* | --- |
* | "Hall of Fame corner with framed photos, plaques, and trophies" |
*
* @param {Hof_Hero_Image_AltInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_hero_image_alt = /** @type {((inputs?: Hof_Hero_Image_AltInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Hero_Image_AltInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_hero_image_alt(inputs)
	if (locale === "de") return de_hof_hero_image_alt(inputs)
	if (locale === "zh") return zh_hof_hero_image_alt(inputs)
	if (locale === "ar") return ar_hof_hero_image_alt(inputs)
	if (locale === "fr") return fr_hof_hero_image_alt(inputs)
	if (locale === "vi") return vi_hof_hero_image_alt(inputs)
	if (locale === "sw") return sw_hof_hero_image_alt(inputs)
	if (locale === "th") return th_hof_hero_image_alt(inputs)
	if (locale === "bs") return bs_hof_hero_image_alt(inputs)
	if (locale === "ja") return ja_hof_hero_image_alt(inputs)
	if (locale === "ko") return ko_hof_hero_image_alt(inputs)
	if (locale === "pt") return pt_hof_hero_image_alt(inputs)
	if (locale === "it") return it_hof_hero_image_alt(inputs)
	if (locale === "sv") return sv_hof_hero_image_alt(inputs)
	if (locale === "nl") return nl_hof_hero_image_alt(inputs)
	if (locale === "da") return da_hof_hero_image_alt(inputs)
	if (locale === "nb") return nb_hof_hero_image_alt(inputs)
	if (locale === "fi") return fi_hof_hero_image_alt(inputs)
	if (locale === "pl") return pl_hof_hero_image_alt(inputs)
	if (locale === "ru") return ru_hof_hero_image_alt(inputs)
	if (locale === "tr") return tr_hof_hero_image_alt(inputs)
	if (locale === "hi") return hi_hof_hero_image_alt(inputs)
	if (locale === "id") return id_hof_hero_image_alt(inputs)
	if (locale === "ms") return ms_hof_hero_image_alt(inputs)
	if (locale === "cs") return cs_hof_hero_image_alt(inputs)
	if (locale === "el") return el_hof_hero_image_alt(inputs)
	if (locale === "he") return he_hof_hero_image_alt(inputs)
	if (locale === "af") return af_hof_hero_image_alt(inputs)
	if (locale === "hu") return hu_hof_hero_image_alt(inputs)
	return en_hof_hero_image_alt(inputs)
});